module.exports = __webpack_public_path__ + "static/info-cf247650798d0469e659002d7a33d5b0.png";